<h2 mat-dialog-title class="dlg-title">
  @if (!ppv.is_sellable) { Ce conditionnement}
  @if (!ppv.is_sellable && !ppv.lnk_product?.is_sold ) { et }
  @if (!ppv.lnk_product?.is_sold ) { Cet article }
  @if (!ppv.is_sellable && !ppv.lnk_product?.is_sold ) { ne sont pas vendable}
  @else { n'est pas vendable}
</h2>

<mat-dialog-content class="dlg-content">
  @if (ppv.lnk_product) {
    <p class="dlg-product-name">
      <a [routerLink]="['/sales/product', ppv.lnk_product.id]" (click)="dialogRef.close(false)">
        {{ ppv.lnk_product.name }}
      </a>
    </p>
  }
  <p class="dlg-warning">Vous pouvez néanmoins le sélectionner pour une vente</p>

  @if (ppv.lnk_product) {
    <section class="info-section">
      <h3 class="section-title">Produit</h3>
      <div class="info-grid">
        <span class="info-label">ID</span>
        <span class="info-value">{{ ppv.lnk_product.id }}</span>

        <span class="info-label">Nom</span>
        <span class="info-value">{{ ppv.lnk_product.name }}</span>

        @if (ppv.lnk_product.attributestring) {
          <span class="info-label">Variante</span>
          <span class="info-value">{{ ppv.lnk_product.attributestring }}</span>
        }

        <span class="info-label">Vendable</span>
        <span class="info-value" [class.status-no]="!ppv.lnk_product.is_sold" [class.status-yes]="ppv.lnk_product.is_sold">
          {{ ppv.lnk_product.is_sold ? 'Oui' : 'Non' }}
        </span>

        <span class="info-label">Achetable</span>
        <span class="info-value" [class.status-no]="!ppv.lnk_product.is_purchased" [class.status-yes]="ppv.lnk_product.is_purchased">
          {{ ppv.lnk_product.is_purchased ? 'Oui' : 'Non' }}
        </span>
      </div>
    </section>
  }

  <section class="info-section">
    <h3 class="section-title">Conditionnement</h3>
    <div class="info-grid">
      <span class="info-label">Type</span>
      <span class="info-value">{{ getPackagingName(ppv.packaging) }}</span>

      <span class="info-label">Qté packaging</span>
      <span class="info-value">{{ ppv.qtybaseuom ?? '—' }}</span>

      @if (ppv.barcode) {
        <span class="info-label">Code-barres</span>
        <span class="info-value">{{ ppv.barcode }}</span>
      }

      <span class="info-label">Vendable</span>
      <span class="info-value" [class.status-no]="!ppv.is_sellable" [class.status-yes]="ppv.is_sellable">
        {{ ppv.is_sellable ? 'Oui' : 'Non' }}
      </span>

      <span class="info-label">Achetable</span>
      <span class="info-value" [class.status-no]="!ppv.is_purchasable" [class.status-yes]="ppv.is_purchasable">
        {{ ppv.is_purchasable ? 'Oui' : 'Non' }}
      </span>
    </div>
  </section>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dlg-actions">
  <button mat-flat-button color="error" class="error" (click)="onAdd(true)">
    <mat-icon>warning</mat-icon>
    Ajouter quand même
  </button>
  <button mat-flat-button color="error" class="error" (click)="onAdd(false)">
    Annuler
  </button>
</mat-dialog-actions>
